import { useTranslation } from 'react-i18next'
import { Box, IconRocket, IconShareAlt, ResponsiveRender, Skeleton } from '@machobear/design-system'
import { ChatIcon } from '@/components/icons'
import { RecommendationBlock } from './recommendation-block'
import { IconWithBackground } from './icon-with-background'
import { useListingActions } from '../../context/listing-actions'
import { ScrollableRow } from '../scrollable-row'
import { useListingDashboardModals } from '../../modals'
import { useListingData } from '../../context/listing-data'

const RecommendationBlocks = () => {
  const { t } = useTranslation()
  const { showModal } = useListingDashboardModals()
  const { goToAutoReply, goToApplications } = useListingActions()

  return (
    <>
      <RecommendationBlock
        title={t('Share your listing')}
        description={t('Get it rented within 7 days')}
        icon={
          <IconWithBackground icon={<IconShareAlt tone="neutral" />} backgroundColor="#307BDE" />
        }
        linkText={t('Start sharing')}
        onClick={showModal('mainDialog')}
      />
      <RecommendationBlock
        title={t('Set up auto-replies')}
        description={t('Reply to inquiries faster')}
        icon={<IconWithBackground icon={<ChatIcon color="white" />} backgroundColor="#307BDE" />}
        linkText={t('Try for free')}
        onClick={goToAutoReply}
      />
      <RecommendationBlock
        title={t('Screen tenants')}
        description={t('Get credit checks & more')}
        icon={<IconWithBackground icon={<IconRocket tone="neutral" />} backgroundColor="#FE5F55" />}
        linkText={t('Start screening')}
        onClick={goToApplications}
      />
    </>
  )
}

const LoadingRecommendationBlocks = () => (
  <>
    <Skeleton.Shape width="225px" height="225px" />
    <Skeleton.Shape width="225px" height="225px" />
    <Skeleton.Shape width="225px" height="225px" />
  </>
)

export const Recommendations = () => {
  const { loading } = useListingData()

  if (loading)
    return (
      <>
        <ResponsiveRender above="mobile">
          <Box
            display="flex"
            gap="small"
            alignItems="flexStart"
            justifyContent="flexStart"
            flexWrap="wrap"
          >
            <LoadingRecommendationBlocks />
          </Box>
        </ResponsiveRender>
        <ResponsiveRender below="tablet">
          <ScrollableRow>
            <LoadingRecommendationBlocks />
          </ScrollableRow>
        </ResponsiveRender>
      </>
    )

  return (
    <>
      <ResponsiveRender above="mobile">
        <Box
          display="flex"
          gap="small"
          alignItems="flexStart"
          justifyContent="flexStart"
          flexWrap="wrap"
        >
          <RecommendationBlocks />
        </Box>
      </ResponsiveRender>
      <ResponsiveRender below="tablet">
        <ScrollableRow>
          <RecommendationBlocks />
        </ScrollableRow>
      </ResponsiveRender>
    </>
  )
}
